import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './libs/element-ui';
import './styles/index.scss';
import './styles/app.scss';

import axios from 'axios';

// 视差滚动
import VueParallaxJs from 'vue-parallax-js';
Vue.use(VueParallaxJs);

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
Vue.prototype.$http = axios;
Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
